import React from "react";
import NavBar from "../components/Nav";
import Footer from "../components/Footer";
import GoToTop from "../components/Top";
import BackTop from "../components/BackToTop";
import faqData from "../assets/js/faq";
import Call from "../components/Call";

function Faq() {
  return (
    <>
      <div className="container-fluid px-3 faq-page-wrap">
        <title>Frequently Asked Questions | RoyalMines Property</title>
        <meta
          name="description"
          content="Find the best real estate and properties in Abuja and Nigeria. Explore a wide range of residential and commercial properties, including houses, apartments, land, and more. Discover trusted real estate agents, listings, and resources to help you buy, sell, or rent properties in Abuja and across Nigeria."
        />
        <meta
          name="keywords"
          content="real estate, properties, Abuja, Nigeria, houses, apartments, land, mortgages, mortgage, real estate agents, listings, buy, sell, rent, residential, commercial, apartments, houses, land, real estate solutions, real estate company"
        />

        <NavBar faq={"active"} />
        <BackTop />

        <div className="container faq-modern-page">
          <header className="faq-modern-hero text-center wow fadeInUp" data-wow-delay="0.1s">
            <div className="mx-auto" style={{ maxWidth: "700px" }}>
              <span className="properties-kicker">Support center</span>
              <h1 className="my-3">Frequently Asked Questions</h1>
              <p className="mb-0">
                Quick answers to common questions about our listings,
                processes, and support.
              </p>
            </div>
          </header>

          <section className="faq-modern-card wow fadeInUp" data-wow-delay="0.2s">
            <div className="accordion accordion-flush faq-accordion" id="accordionFlushExample">
              {faqData.map((e, i) => {
                return (
                  <div className="accordion-item faq-item" key={`faq-item-${i}`}>
                    <h2 className="accordion-header" id={`flush-headingOne-${i}`}>
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#flush-collapseOne-${i}`}
                        aria-expanded="false"
                        aria-controls={`flush-collapseOne-${i}`}
                      >
                        {e.q}
                      </button>
                    </h2>
                    <div
                      id={`flush-collapseOne-${i}`}
                      className="accordion-collapse collapse"
                      aria-labelledby={`flush-headingOne-${i}`}
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">{e.a}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>

          <section className="faq-help-card mt-4">
            <div className="faq-help-head">
              <h2>Still have questions?</h2>
              <p>Feel free to contact us for personalized assistance.</p>
            </div>
            <div className="faq-help-content">
              <Call />
            </div>
          </section>
        </div>
      </div>

      <div>
        <Footer />
      </div>
      <GoToTop />
    </>
  );
}

export default Faq;
